const names = {
  "ceis_infos_government_base_cpf": "Informações no Cadastro de Empresas Inidôneas e Suspensas",
  "Informações no Cadastro de Empresas Inidôneas e Suspensas": "Informações no Cadastro de Empresas Inidôneas e Suspensas",
  
  "certificate_tax_debts_federal_cpf": "Certidão de Débitos Tributários Federais e da Dívida Ativa da União",
  "Certidão de Débitos Tributários Federais e da Dívida Ativa da União": "Certidão de Débitos Tributários Federais e da Dívida Ativa da União",
  
  "certificate_tax_debts_sp_cpf": "Certidão Negativa de Débitos Tributários de SP",
  "Certidão Negativa de Débitos Tributários de SP": "Certidão Negativa de Débitos Tributários de SP",
  
  "cnep_infos_government_base_cpf": "Informações de Pessoa Física no Cadastro Nacional de Empresas Punidas",
  "Informações de Pessoa Física no Cadastro Nacional de Empresas Punidas": "Informações de Pessoa Física no Cadastro Nacional de Empresas Punidas",
  
  "court_warrant_bnmp_cpf": "Mandados judiciais do BNMP",
  "Mandados judiciais do BNMP": "Mandados judiciais do BNMP",
  
  "criminal_record_federal_police": "Certidão de antecedentes criminais da PF",
  "Certidão de antecedentes criminais da PF": "Certidão de antecedentes criminais da PF",
  
  "electoral_financing_cpf": "Financiamentos de Campanhas Eleitorais",
  "Financiamentos de Campanhas Eleitorais": "Financiamentos de Campanhas Eleitorais",
  
  "ibama_assessment_cpf": "IBAMA - Consulta de Autuações Ambientais",
  "IBAMA - Consulta de Autuações Ambientais": "IBAMA - Consulta de Autuações Ambientais",
  
  "ibama_embargo_cpf": "IBAMA - Consulta de Embargos",
  "IBAMA - Consulta de Embargos": "IBAMA - Consulta de Embargos",
  
  "ibama_negative_certificate_cpf": "IBAMA - Consulta de Certidões Negativas",
  "IBAMA - Consulta de Certidões Negativas": "IBAMA - Consulta de Certidões Negativas",
  
  "ieptb_protests_registry_cpf": "Protestos encontrados no IEPTB",
  "Protestos encontrados no IEPTB": "Protestos encontrados no IEPTB",
  
  "irregular_accounts_cpf": "Contas Irregulares",
  "Contas Irregulares": "Contas Irregulares",
  
  "irregular_bidders_cpf": "Licitantes Inidôneos",
  "Licitantes Inidôneos": "Licitantes Inidôneos",
  
  "irregular_electoral_accounts_cpf": "Contas Irregulares Eleitorais",
  "Contas Irregulares Eleitorais": "Contas Irregulares Eleitorais",
  
  "mpf_extrajudicial_procedures_cpf": "Certidão negativa de procedimentos extrajudiciais do MPF",
  "Certidão negativa de procedimentos extrajudiciais do MPF": "Certidão negativa de procedimentos extrajudiciais do MPF",
  
  "negative_certificate_irregular_accounts_cpf": "Certidão negativa de contas irregulares",
  "Certidão negativa de contas irregulares": "Certidão negativa de contas irregulares",
  
  "sit_certificate_cpf": "Certidão de Débitos Trabalhistas do SIT",
  "Certidão de Débitos Trabalhistas do SIT": "Certidão de Débitos Trabalhistas do SIT",
  
  "social_assistance_person": "Benefícios e Assistência Social",
  "Benefícios e Assistência Social": "Benefícios e Assistência Social",
  
  "trf2_certificates_civil_cpf": "TRF-2 Certidão - Cível (pode haver homônimos)",
  "TRF-2 Certidão - Civil (pode haver homônimos)": "TRF-2 Certidão - Cível (pode haver homônimos)",
  
  "trf2_certificates_criminal_cpf": "TRF-2 Certidão - Criminal (pode haver homônimos)",
  "TRF-2 Certidão - Criminal (pode haver homônimos)": "TRF-2 Certidão - Criminal (pode haver homônimos)",
  
  "trf2_certificates_electoral_cpf": "TRF-2 Certidão - Eleitoral (pode haver homônimos)",
  "TRF-2 Certidão - Eleitoral (pode haver homônimos)": "TRF-2 Certidão - Eleitoral (pode haver homônimos)",
  
  "trf3_certificates_civil_cpf": "TRF-3 Certidão - Cível",
  "TRF-3 Certidão - Civil": "TRF-3 Certidão - Cível",
  
  "trf3_certificates_criminal_cpf": "TRF-3 Certidão - Criminal",
  "TRF-3 Certidão - Criminal": "TRF-3 Certidão - Criminal",
  
  "trf3_certificates_electoral_cpf": "TRF-3 Certidão - Eleitoral",
  "TRF-3 Certidão - Electoral": "TRF-3 Certidão - Eleitoral",
  
  "trf5_certificates_criminal_cpf": "TRF-5 Certidão - Criminal (pode haver homônimos)",
  "TRF-5 Certidão - Criminal (pode haver homônimos)": "TRF-5 Certidão - Criminal (pode haver homônimos)",
  
  "trf5_certificates_electoral_cpf": "TRF-5 Certidão - Eleitoral (pode haver homônimos)",
  "TRF-5 Certidão - Eleitoral (pode haver homônimos)": "TRF-5 Certidão - Eleitoral (pode haver homônimos)",
  
  "trf5_certificates_distribution_cpf": "TRF-5 Certidão - Distribuição (pode haver homônimos)",
  "TRF-5 Certidão - Distribuição (pode haver homônimos)": "TRF-5 Certidão - Distribuição (pode haver homônimos)",
  
  "trf1_pje_process_first_instance_cpf": "TRF-1 PJE Processos 1ª instância",
  "TRF-1 PJE Processos 1ª instância": "TRF-1 PJE Processos 1ª instância",
  
  "trf1_pje_process_second_instance_cpf": "TRF-1 PJE Processos 2ª instância",
  "TRF-1 PJE Processos 2ª instância": "TRF-1 PJE Processos 2ª instância",
  
  "trf1_process_all_instances_cpf": "TRF-1 Processos de todas as instâncias",
  "TRF-1 Processos todas instâncias": "TRF-1 Processos de todas as instâncias",
  
  "trf2_process_all_instances_cpf": "TRF-2 Processos de todas as instâncias",
  "TRF-2 Processos todas instâncias": "TRF-2 Processos de todas as instâncias",
  
  "trf3_pje_process_first_instance_cpf": "TRF-3 PJE Processos 1ª instância",
  "TRF-3 PJE Processos 1ª instância": "TRF-3 PJE Processos 1ª instância",
  
  "trf3_pje_process_second_instance_cpf": "TRF-3 PJE Processos 2ª instância",
  "TRF-3 PJE Processos 2ª instância": "TRF-3 PJE Processos 2ª instância",
  
  "trf3_process_second_instance_cpf": "TRF-3 Processos 2ª instância",
  "TRF-3 Processos 2ª instância": "TRF-3 Processos 2ª instância",
  
  "trf4_process_all_instances_cpf": "TRF-4 Processos de todas as instâncias",
  "TRF-4 Processos todas instâncias": "TRF-4 Processos de todas as instâncias",
  
  "trf5_pje_process_all_instances_cpf": "TRF-5 PJE Processos de todas as instâncias",
  "TRF-5 PJE Processos todas instâncias": "TRF-5 PJE Processos de todas as instâncias",
  
  "trf5_process_all_instances_cpf": "TRF-5 Processos de todas as instâncias",
  "TRF-5 Processos todas instâncias": "TRF-5 Processos de todas as instâncias",
  
  "trf6_processes_first_instance_cpf": "TRF-6 Processos 1ª instância",
  "TRF-6 Processos 1ª instância": "TRF-6 Processos 1ª instância",
  
  "trf6_processes_second_instance_cpf": "TRF-6 Processos 2ª instância",
  "TRF-6 Processos 2ª instância": "TRF-6 Processos 2ª instância",
  
  "trt1_certificates_pje_cpf": "TRT-1 PJE - Certidão Trabalhista",
  "TRT-1 PJE - Certidão Trabalhista": "TRT-1 PJE - Certidão Trabalhista",
  
  "trt2_certificates_pje_cpf": "TRT-2 PJE - Certidão Trabalhista",
  "TRT-2 PJE - Certidão Trabalhista": "TRT-2 PJE - Certidão Trabalhista",
  
  "trt4_certificates_pje_cpf": "TRT-4 PJE - Certidão Trabalhista",
  "TRT-4 PJE - Certidão Trabalhista": "TRT-4 PJE - Certidão Trabalhista",
  
  "trt5_certificates_pje_cpf": "TRT-5 PJE - Certidão Trabalhista",
  "TRT-5 PJE - Certidão Trabalhista": "TRT-5 PJE - Certidão Trabalhista",
  
  "trt6_certificates_pje_cpf": "TRT-6 PJE - Certidão Trabalhista",
  "TRT-6 PJE - Certidão Trabalhista": "TRT-6 PJE - Certidão Trabalhista",
  
  "trt7_certificates_pje_cpf": "TRT-7 PJE - Certidão Trabalhista",
  "TRT-7 PJE - Certidão Trabalhista": "TRT-7 PJE - Certidão Trabalhista",
  
  "trt8_certificates_pje_cpf": "TRT-8 PJE - Certidão Trabalhista",
  "TRT-8 PJE - Certidão Trabalhista": "TRT-8 PJE - Certidão Trabalhista",
  
  "trt9_certificates_pje_cpf": "TRT-9 PJE - Certidão Trabalhista",
  "TRT-9 PJE - Certidão Trabalhista": "TRT-9 PJE - Certidão Trabalhista",
  
  "trt10_certificates_pje_cpf": "TRT-10 PJE - Certidão Trabalhista",
  "TRT-10 PJE - Certidão Trabalhista": "TRT-10 PJE - Certidão Trabalhista",
  
  "trt11_certificates_pje_cpf": "TRT-11 PJE - Certidão Trabalhista",
  "TRT-11 PJE - Certidão Trabalhista": "TRT-11 PJE - Certidão Trabalhista",
  
  "trt13_certificates_pje_cpf": "TRT-13 PJE - Certidão Trabalhista",
  "TRT-13 PJE - Certidão Trabalhista": "TRT-13 PJE - Certidão Trabalhista",
  
  "trt14_certificates_pje_cpf": "TRT-14 PJE - Certidão Trabalhista",
  "TRT-14 PJE - Certidão Trabalhista": "TRT-14 PJE - Certidão Trabalhista",
  
  "trt15_certificates_pje_cpf": "TRT-15 PJE - Certidão Trabalhista",
  "TRT-15 PJE - Certidão Trabalhista": "TRT-15 PJE - Certidão Trabalhista",
  
  "trt16_certificates_pje_cpf": "TRT-16 PJE - Certidão Trabalhista",
  "TRT-16 PJE - Certidão Trabalhista": "TRT-16 PJE - Certidão Trabalhista",
  
  "trt17_certificates_pje_cpf": "TRT-17 PJE - Certidão Trabalhista",
  "TRT-17 PJE - Certidão Trabalhista": "TRT-17 PJE - Certidão Trabalhista",
  
  "trt18_certificates_pje_cpf": "TRT-18 PJE - Certidão Trabalhista",
  "TRT-18 PJE - Certidão Trabalhista": "TRT-18 PJE - Certidão Trabalhista",
  
  "trt19_certificates_pje_cpf": "TRT-19 PJE - Certidão Trabalhista",
  "TRT-19 PJE - Certidão Trabalhista": "TRT-19 PJE - Certidão Trabalhista",
  
  "trt20_certificates_pje_cpf": "TRT-20 PJE - Certidão Trabalhista",
  "TRT-20 PJE - Certidão Trabalhista": "TRT-20 PJE - Certidão Trabalhista",
  
  "trt21_certificates_pje_cpf": "TRT-21 PJE - Certidão Trabalhista",
  "TRT-21 PJE - Certidão Trabalhista": "TRT-21 PJE - Certidão Trabalhista",
  
  "trt22_certificates_pje_cpf": "TRT-22 PJE - Certidão Trabalhista",
  "TRT-22 PJE - Certidão Trabalhista": "TRT-22 PJE - Certidão Trabalhista",
  
  "trt23_certificates_pje_cpf": "TRT-23 PJE - Certidão Trabalhista",
  "TRT-23 PJE - Certidão Trabalhista": "TRT-23 PJE - Certidão Trabalhista",
  
  "trt24_certificates_pje_cpf": "TRT-24 PJE - Certidão Trabalhista",
  "TRT-24 PJE - Certidão Trabalhista": "TRT-24 PJE - Certidão Trabalhista",
  
  "trt1_certificates_physical_cpf": "TRT-1 Fisico - Certidão trabalhista",
  "TRT-1 Fisico - Certidão trabalhista": "TRT-1 Fisico - Certidão trabalhista",
  
  "trt2_sp_certificate_cpf": "TRT-2 Fisico - Certidão trabalhista",
  "TRT-2 Fisico - Certidão trabalhista": "TRT-2 Fisico - Certidão trabalhista",
  
  "trt3_certificates_physical_cpf": "TRT-3 Fisico - Certidão trabalhista",
  "TRT-3 Fisico - Certidão trabalhista": "TRT-3 Fisico - Certidão trabalhista",
  
  "trt5_certificates_physical_cpf": "TRT-5 Fisico - Certidão trabalhista",
  "TRT-5 Fisico - Certidão trabalhista": "TRT-5 Fisico - Certidão trabalhista",
  
  "trt7_certificates_physical_cpf": "TRT-7 Fisico - Certidão trabalhista",
  "TRT-7 Fisico - Certidão trabalhista": "TRT-7 Fisico - Certidão trabalhista",
  
  "trt11_certificates_physical_cpf": "TRT-11 Fisico - Certidão trabalhista",
  "TRT-11 Fisico - Certidão trabalhista": "TRT-11 Fisico - Certidão trabalhista",
  
  "trt12_certificates_physical_cpf": "TRT-12 Fisico - Certidão trabalhista",
  "TRT-12 Fisico - Certidão trabalhista": "TRT-12 Fisico - Certidão trabalhista",
  
  "trt15_certificates_physical_cpf": "TRT-15 Fisico - Certidão trabalhista",
  "TRT-15 Fisico - Certidão trabalhista": "TRT-15 Fisico - Certidão trabalhista",
  
  "trt18_certificates_physical_first_instance_cpf": "TRT-18 Fisico - Certidão trabalhista - 1ª instância",
  "TRT-18 Fisico - Certidão trabalhista - 1ª instância": "TRT-18 Fisico - Certidão trabalhista - 1ª instância",
  
  "trt18_certificates_physical_second_instance_cpf": "TRT-18 Fisico - Certidão trabalhista - 2ª instância",
  "TRT-18 Fisico - Certidão trabalhista - 2ª instância": "TRT-18 Fisico - Certidão trabalhista - 2ª instância",
  
  "trt20_certificates_physical_cpf": "TRT-20 Fisico - Certidão trabalhista",
  "TRT-20 Fisico - Certidão trabalhista": "TRT-20 Fisico - Certidão trabalhista",
  
  "trt21_certificates_physical_cpf": "TRT-21 Fisico - Certidão trabalhista",
  "TRT-21 Fisico - Certidão trabalhista": "TRT-21 Fisico - Certidão trabalhista",
  
  "tst_certificate_cpf": "Certidão de débito trabalhista do TST",
  "Certidão de débito trabalhista do TST": "Certidão de débito trabalhista do TST",
  
  "unabled_people_cpf": "Relação de Inabilitados",
  "Relação de Inabilitados": "Relação de Inabilitados",
  
  "work_info_rais_base": "RAIS - Vinculos empregativos formais",
  "RAIS - Vinculos empregativos formais": "RAIS - Vinculos empregativos formais",
  
  "pje_ap_process_first_instance_cpf": "PJE-AP 1ª instância",
  "PJE-AP 1ª instância": "PJE-AP 1ª instância",
  
  "pje_ba_process_first_instance_cpf": "PJE-BA 1ª instância",
  "PJE-BA 1ª instância": "PJE-BA 1ª instância",
  
  "pje_df_process_first_instance_cpf": "PJE-DF 1ª instância",
  "PJE-DF 1ª instância": "PJE-DF 1ª instância",
  
  "pje_ma_process_first_instance_cpf": "PJE-MA 1ª instância",
  "PJE-MA 1ª instância": "PJE-MA 1ª instância",
  
  "pje_mg_process_first_instance_cpf": "PJE-MG 1ª instância",
  "PJE-MG 1ª instância": "PJE-MG 1ª instância",
  
  "pje_mt_process_first_instance_cpf": "PJE-MT 1ª instância",
  "PJE-MT 1ª instância": "PJE-MT 1ª instância",
  
  "pje_pb_process_first_instance_cpf": "PJE-PB 1ª instância",
  "PJE-PB 1ª instância": "PJE-PB 1ª instância",
  
  "pje_pe_process_first_instance_cpf": "PJE-PE 1ª instância",
  "PJE-PE 1ª instância": "PJE-PE 1ª instância",
  
  "pje_pi_process_first_instance_cpf": "PJE-PI 1ª instância",
  "PJE-PI 1ª instância": "PJE-PI 1ª instância",
  
  "pje_ro_process_first_instance_cpf": "PJE-RO 1ª instância",
  "PJE-RO 1ª instância": "PJE-RO 1ª instância",
  
  "pje_rs_process_first_instance_cpf": "PJE-RS 1ª instância",
  "PJE-RS 1ª instância": "PJE-RS 1ª instância",
  
  "pje_se_process_first_instance_cpf": "PJE-SE 1ª instância",
  "PJE-SE 1ª instância": "PJE-SE 1ª instância",
  
  "pje_ce_process_first_instance_cpf": "PJE-CE 1ª instância",
  "PJE-CE 1ª instância": "PJE-CE 1ª instância",
  
  "pje_es_process_first_instance_cpf": "PJE-ES 1ª instância",
  "PJE-ES 1ª instância": "PJE-ES 1ª instância",
  
  "pje_rr_process_first_instance_cpf": "PJE-RR 1ª instância",
  "PJE-RR 1ª instância": "PJE-RR 1ª instância",
  
  "pje_rn_process_first_instance_cpf": "PJE-RN 1ª instância",
  "PJE-RN 1ª instância": "PJE-RN 1ª instância",
  
  "pje_rj_process_first_instance_cpf": "PJE-RJ 1ª instância",
  "PJE-RJ 1ª instância": "PJE-RJ 1ª instância",
  
  "pje_ap_process_second_instance_cpf": "PJE-AP 2ª instância",
  "PJE-AP 2ª instância": "PJE-AP 2ª instância",
  
  "pje_ba_process_second_instance_cpf": "PJE-BA 2ª instância",
  "PJE-BA 2ª instância": "PJE-BA 2ª instância",
  
  "pje_ce_process_second_instance_cpf": "PJE-CE 2ª instância",
  "PJE-CE 2ª instância": "PJE-CE 2ª instância",
  
  "pje_df_process_second_instance_cpf": "PJE-DF 2ª instância",
  "PJE-DF 2ª instância": "PJE-DF 2ª instância",
  
  "pje_es_process_second_instance_cpf": "PJE-ES 2ª instância",
  "PJE-ES 2ª instância": "PJE-ES 2ª instância",
  
  "pje_ma_process_second_instance_cpf": "PJE-MA 2ª instância",
  "PJE-MA 2ª instância": "PJE-MA 2ª instância",
  
  "pje_mt_process_second_instance_cpf": "PJE-MT 2ª instância",
  "PJE-MT 2ª instância": "PJE-MT 2ª instância",
  
  "pje_pb_process_second_instance_cpf": "PJE-PB 2ª instância",
  "PJE-PB 2ª instância": "PJE-PB 2ª instância",
  
  "pje_pe_process_second_instance_cpf": "PJE-PE 2ª instância",
  "PJE-PE 2ª instância": "PJE-PE 2ª instância",
  
  "pje_pi_process_second_instance_cpf": "PJE-PI 2ª instância",
  "PJE-PI 2ª instância": "PJE-PI 2ª instância",
  
  "pje_rj_process_second_instance_cpf": "PJE-RJ 2ª instância",
  "PJE-RJ 2ª instância": "PJE-RJ 2ª instância",
  
  "pje_rn_process_second_instance_cpf": "PJE-RN 2ª instância",
  "PJE-RN 2ª instância": "PJE-RN 2ª instância",
  
  "pje_ro_process_second_instance_cpf": "PJE-RO 2ª instância",
  "PJE-RO 2ª instância": "PJE-RO 2ª instância",
  
  "pje_rr_process_second_instance_cpf": "PJE-RR 2ª instância",
  "PJE-RR 2ª instância": "PJE-RR 2ª instância",
  
  "tj_ac_process_first_instance_doc_number": "TJ-AC 1ª instância",
  "TJ-AC 1ª instância": "TJ-AC 1ª instância",
  
  "tj_al_process_first_instance_doc_number": "TJ-AL 1ª instância",
  "TJ-AL 1ª instância": "TJ-AL 1ª instância",
  
  "tj_am_process_first_instance_doc_number": "TJ-AM 1ª instância",
  "TJ-AM 1ª instância": "TJ-AM 1ª instância",
  
  "tj_ap_process_all_instances_cpf": "TJ-AP 1ª e 2ª instância",
  "TJ-AP 1ª e 2ª instância": "TJ-AP 1ª e 2ª instância",
  
  "tj_ba_process_first_instance_doc_number": "TJ-BA 1ª instância",
  "TJ-BA 1ª instância": "TJ-BA 1ª instância",
  
  "tj_ce_process_first_instance_doc_number": "TJ-CE 1ª instância",
  "TJ-CE 1ª instância": "TJ-CE 1ª instância",
  
  "tj_go_process_all_instances_cpf": "TJ-GO 1ª e 2ª instância",
  "TJ-GO 1ª e 2ª instância": "TJ-GO 1ª e 2ª instância",
  
  "tj_ma_process_first_instance_cpf": "TJ-MA 1ª instância",
  "TJ-MA 1ª instância": "TJ-MA 1ª instância",
  
  "tj_ms_process_first_instance_doc_number": "TJ-MS 1ª instância",
  "TJ-MS 1ª instância": "TJ-MS 1ª instância",
  
  "tj_rj_jus_process_first_instance_civil_cpf": "TJ-RJ 1ª instância cível",
  "TJ-RJ 1ª instância cívil": "TJ-RJ 1ª instância cível",
  
  "tj_rj_jus_process_first_instance_criminal_cpf": "TJ-RJ 1ª instância criminal",
  "TJ-RJ 1ª instância criminal": "TJ-RJ 1ª instância criminal",
  
  "tj_rs_processes_cpf": "TJ-RS 1ª e 2ª instância",
  "TJ-RS 1ª e 2ª instância": "TJ-RS 1ª e 2ª instância",
  
  "projudi_pa_process_cpf": "TJ-PA 1ª e 2ª instância",
  "TJ-PA 1ª e 2ª instância": "TJ-PA 1ª e 2ª instância",
  
  "tj_pe_process_all_instances_cpf": "TJ-PE 1ª e 2ª instância",
  "TJ-PE 1ª e 2ª instância": "TJ-PE 1ª e 2ª instância",
  
  "tj_pr_process_first_instance_cpf": "TJ-PR 1ª instância",
  "TJ-PR 1ª instância": "TJ-PR 1ª instância",
  
  "tj_sc_process_first_instance_doc_number": "TJ-SC 1ª instância",
  "TJ-SC 1ª instância": "TJ-SC 1ª instância",
  
  "tj_se_process_first_instance_cpf": "TJ-SE 1ª instância",
  "TJ-SE 1ª instância": "TJ-SE 1ª instância",
  
  "tj_sp_process_first_instance_doc_number": "TJ-SP 1ª instância",
  "TJ-SP 1ª instância": "TJ-SP 1ª instância",
  
  "tj_ac_process_second_instance_doc_number": "TJ-AC 2ª instância",
  "TJ-AC 2ª instância": "TJ-AC 2ª instância",
  
  "tj_al_process_second_instance_doc_number": "TJ-AL 2ª instância",
  "TJ-AL 2ª instância": "TJ-AL 2ª instância",
  
  "tj_am_process_second_instance_doc_number": "TJ-AM 2ª instância",
  "TJ-AM 2ª instância": "TJ-AM 2ª instância",
  
  "tj_ba_process_second_instance_doc_number": "TJ-BA 2ª instância",
  "TJ-BA 2ª instância": "TJ-BA 2ª instância",
  
  "tj_ce_process_second_instance_doc_number": "TJ-CE 2ª instância",
  "TJ-CE 2ª instância": "TJ-CE 2ª instância",
  
  "tj_mg_process_second_instance_cpf": "TJ-MG 2ª instância",
  "TJ-MG 2ª instância": "TJ-MG 2ª instância",
  
  "tj_ms_process_second_instance_doc_number": "TJ-MS 2ª instância",
  "TJ-MS 2ª instância": "TJ-MS 2ª instância",
  
  "tj_pr_process_second_instance_cpf": "TJ-PR 2ª instância",
  "TJ-PR 2ª instância": "TJ-PR 2ª instância",
  
  "tj_rj_jus_process_second_instance_cpf": "TJ-RJ 2ª instância",
  "TJ-RJ 2ª instância": "TJ-RJ 2ª instância",
  
  "tj_sc_process_second_instance_doc_number": "TJ-SC 2ª instância",
  "TJ-SC 2ª instância": "TJ-SC 2ª instância",
  
  "tj_sp_process_second_instance_doc_number": "TJ-SP 2ª instância",
  "TJ-SP 2ª instância": "TJ-SP 2ª instância",
  
  "tj_se_process_second_instance_cpf": "TJ-SE 2ª instância",
  "TJ-SE 2ª instância": "TJ-SE 2ª instância",
  
  "stf_process_name": "Processos no STF (pode haver homônimos)",
  "Processos no STF (pode haver homônimos)": "Processos no STF (pode haver homônimos)",
  
  "stj_process_name": "Processos no STJ (pode haver homônimos)",
  "Processos no STJ (pode haver homônimos)": "Processos no STJ (pode haver homônimos)",
  
  "administrative_improbity_cpf": "Certidão negativa de ato de improbidade e inelegibilidade CNJ",
  "Certidão negativa de ato de improbidade e inelegibilidade CNJ": "Certidão negativa de ato de improbidade e inelegibilidade CNJ",
  
  "cvm_administrative_process": "CVM - Processo Administrativo (pode haver homônimos)",
  "CVM - Processo Administrativo (pode haver homônimos)": "CVM - Processo Administrativo (pode haver homônimos)",
  
  "cvm_sanctioning_administrative_process": "CVM - Processo Administrativo Sancionador (pode haver homônimos)",
  "CVM - Processo Administrativo Sancionador (pode haver homônimos)": "CVM - Processo Administrativo Sancionador (pode haver homônimos)",
  
  "trf1_certificates_civel_cpf": "TRF-1 Certidão - Civel (pode haver homônimos)",
  "TRF-1 Certidão - Civel (pode haver homônimos)": "TRF-1 Certidão - Civel (pode haver homônimos)",
  
  "trf1_certificates_criminal_cpf": "TRF-1 Certidão - Criminal (pode haver homônimos)",
  "TRF-1 Certidão - Criminal (pode haver homônimos)": "TRF-1 Certidão - Criminal (pode haver homônimos)",
  
  "trf1_certificates_electoral_cpf": "TRF-1 Certidão - Eleitoral (pode haver homônimos)",
  "TRF-1 Certidão - Eleitoral (pode haver homônimos)": "TRF-1 Certidão - Eleitoral (pode haver homônimos)",
  
  "trf3_certificates_electoral_ms_cpf": "TRF-3 Certidão - Eleitoral - MS",
  "TRF-3 Certidão - Eleitoral - MS": "TRF-3 Certidão - Eleitoral - MS",
  
  "trf3_certificates_electoral_sp_cpf": "TRF-3 Certidão - Eleitoral - SP",
  "TRF-3 Certidão - Eleitoral - SP": "TRF-3 Certidão - Eleitoral - SP",
  
  "trf3_certificates_electoral_regional_cpf": "TRF-3 Certidão - Eleitoral - REGIONAL",
  "TRF-3 Certidão - Eleitoral - REGIONAL": "TRF-3 Certidão - Eleitoral - REGIONAL",
  
  "trf3_certificates_civil_ms_cpf": "TRF-3 Certidão - Cível - MS",
  "TRF-3 Certidão - Civil - MS": "TRF-3 Certidão - Cível - MS",
  
  "trf3_certificates_civil_sp_cpf": "TRF-3 Certidão - Cível - SP",
  "TRF-3 Certidão - Civil - SP": "TRF-3 Certidão - Cível - SP",
  
  "trf3_certificates_civil_regional_cpf": "TRF-3 Certidão - Cível - REGIONAL",
  "TRF-3 Certidão - Civil - REGIONAL": "TRF-3 Certidão - Cível - REGIONAL",
  
  "trf3_certificates_criminal_ms_cpf": "TRF-3 Certidão - Criminal - MS",
  "TRF-3 Certidão - Criminal - MS": "TRF-3 Certidão - Criminal - MS",
  
  "trf3_certificates_criminal_sp_cpf": "TRF-3 Certidão - Criminal - SP",
  "TRF-3 Certidão - Criminal - SP": "TRF-3 Certidão - Criminal - SP",
  
  "trf3_certificates_criminal_regional_cpf": "TRF-3 Certidão - Criminal - REGIONAL",
  "TRF-3 Certidão - Criminal - REGIONAL": "TRF-3 Certidão - Criminal - REGIONAL",
  
  "trf4_certificates_civel_cpf": "TRF-4 Certidão - Civel (pode haver homônimos)",
  "TRF-4 Certidão - Civel (pode haver homônimos)": "TRF-4 Certidão - Civel (pode haver homônimos)",
  
  "trf4_certificates_criminal_cpf": "TRF-4 Certidão - Criminal (pode haver homônimos)",
  "TRF-4 Certidão - Criminal (pode haver homônimos)": "TRF-4 Certidão - Criminal (pode haver homônimos)",
  
  "trf4_certificates_electoral_cpf": "TRF-4 Certidão - Eleitoral (pode haver homônimos)",
  "TRF-4 Certidão - Eleitoral (pode haver homônimos)": "TRF-4 Certidão - Eleitoral (pode haver homônimos)",
  }

  export const correctServiceName = (nameOrServiceId) => names[nameOrServiceId] || nameOrServiceId

